// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"PermissionGroupSection_multiselect__yS4l4","singleSelect":"PermissionGroupSection_singleSelect__f8uUN","sisSync":"PermissionGroupSection_sisSync__j_zBD"};